module.exports = __webpack_public_path__ + "img/1st-grade-en.4730fcee.png";